import { useContext, useState } from 'react'
import { IBatteryData } from '../../../../../../../app/entities/BatteryData'
import { VanContext } from '../../../../../global/context/van-context/VanContext'
import { UserContext } from '../../../../../base/components/base-container/BaseContainer'
import { PERMISSIONS } from '../../../../../global/constants/permissions'
import userHasPermission from '../../../../../global/utils/user/has-permission'
import { BatteryDataModal } from './BatteryDataModal'
import styles from './styles.module.css'

function formatDateTime(date: Date): string {
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
}

export function BatteryData() {
  const { vanData } = useContext(VanContext)
  const { user } = useContext(UserContext)
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Check if user has permission to view battery data
  const canViewBatteryData = userHasPermission(user).allow(
    PERMISSIONS.VANS.CATEGORY,
    PERMISSIONS.VANS.ENTRIES.VIEW_BATTERY_DATA.NAME,
  )

  if (!canViewBatteryData) {
    return null // Don't show battery data section if user doesn't have permission
  }

  const batteryData = vanData.currentBatteryData || []

  function handleOpen() {
    // Only open modal if there's battery data available
    if (batteryData.length > 0) {
      setIsModalOpen(true)
    }
  }

  function handleClose() {
    setIsModalOpen(false)
  }

  function getBatteryDataDisplay(batteryData: IBatteryData[]) {
    if (batteryData.length === 0) {
      return 'No battery data available'
    }
    return batteryData.map((data, index) => {
      const timestamp = formatDateTime(new Date(data.created))
      const stateOfCharge = data.stateOfCharge
      const voltage = data.voltage
      const current = data.current
      const capacity = data.capacity
      const temperature = data.temperature
      return (
        <div key={index}>
          <div>
            <span style={{ fontStyle: 'italic' }}>{data.batteryName}</span>
            {', '}
            {timestamp}
          </div>
          <div style={{ paddingLeft: '20px' }}>
            {stateOfCharge}%, {voltage}V, {current}A, {capacity}aH,{' '}
            {temperature}°F
          </div>
        </div>
      )
    })
  }

  return (
    <>
      <BatteryDataModal
        isOpen={isModalOpen}
        handleClosed={handleClose}
        vanObjectId={vanData.objectId || ''}
        vanName={vanData.name || ''}
        hasBatteryData={batteryData.length > 0}
      />
      <div className={styles.subsectionTitle}>Battery Data</div>
      <button
        className={styles.stateOfChargeContainer}
        onClick={handleOpen}
        style={{
          cursor: batteryData.length > 0 ? 'pointer' : 'default',
        }}
        disabled={batteryData.length === 0}
      >
        {getBatteryDataDisplay(batteryData)}
      </button>
    </>
  )
}